import '@tiptap/extension-text-style';
import { Extension } from '@tiptap/core';
export var Background = Extension.create({
    name: 'background',
    addOptions: function () {
        return {
            types: ['textStyle']
        };
    },
    addGlobalAttributes: function () {
        return [
            {
                types: this.options.types,
                attributes: {
                    background: {
                        default: null,
                        parseHTML: function (element) { var _a; return (_a = element.style.background) === null || _a === void 0 ? void 0 : _a.replace(/['"]+/g, ''); },
                        renderHTML: function (attributes) {
                            // 注意：判断的是 background 而非 color（原为复制 color 扩展时的笔误，
                            // 会导致只设背景色时样式永远不渲染）
                            if (!attributes.background) {
                                return {};
                            }
                            return {
                                style: "background: ".concat(attributes.background)
                            };
                        }
                    }
                }
            }
        ];
    },
    addCommands: function () {
        return {
            setBackground: function (background) {
                return function (_a) {
                    var chain = _a.chain;
                    return chain().setMark('textStyle', { background: background }).run();
                };
            },
            unsetBackground: function () {
                return function (_a) {
                    var chain = _a.chain;
                    return chain().setMark('textStyle', { background: null }).removeEmptyTextStyle().run();
                };
            }
        };
    }
});
